import { apiClient } from '@app/api';
import { purgeRegisteredStores } from '@app/core/stores';
import { useAuth0 } from '@auth0/auth0-react';
import debugFn from 'debug';
import posthog from 'posthog-js';
import { useImpersonation } from '../../impersonation';

const debug = debugFn('LogoutPage');

export function useLogout() {
  const { clearAll } = useImpersonation();
  const { logout } = useAuth0();

  return ({ returnTo }: { returnTo?: string } = {}) => {
    debug('Logging out');

    clearAll();
    purgeRegisteredStores();
    apiClient.setTokenProvider(null);
    // Use the global instance so reset still runs on /logout after the provider unmounts.
    posthog?.reset();

    logout({
      logoutParams: {
        returnTo: encodeURI(window.location.origin + (returnTo ?? '')),
      },
    });
  };
}
